import { ACL_DIRTY_STATUS } from "component/utils/Constant";
import React, { useContext, useEffect, useState } from "react";
import {
  isAclApplicable,
  isRouteGuardApplicable,
  saveAclGuardStatusToStorage,
} from "component/utils/Helper";
import { AclContext, IAclContext } from "component/AclGuard/AclGuard";

// Forwarding ref in HOC
export const withAuth = (Component: React.FC<any>) => {
  const InputComponentWrapper = React.forwardRef<any, any>((props, ref) => {
    const context: IAclContext = useContext(AclContext);
    const [isDisabled, setIsDisabled] = useState(props.disabled ?? false);

    useEffect(() => {
      if (!isAclApplicable()) return;

      if (!props?.isIgnoreAccessLevel && context?.isOn) {
        setIsDisabled(context.read);
      }
    }, []);

    useEffect(() => {
      if (!isAclApplicable()) return;

      if (!props?.isIgnoreAccessLevel && context.isOn) {
        setIsDisabled(context.read);
      } else {
        setIsDisabled(false);
      }
    }, [context]);

    const onChange = (e: any) => {
      reportFormDirty();
      props.onChange(e);
    };

    const reportFormDirty = () => {
      if (isRouteGuardApplicable() && context.isOn) {
        saveAclGuardStatusToStorage(context.name, ACL_DIRTY_STATUS.Y);
      }
    };

    return (
      <Component
        {...props}
        ref={ref} // Pass the ref down to the wrapped component
        onChange={onChange}
        isIgnoreAccessLevel={
          props.isIgnoreAccessLevel !== undefined ? props.isIgnoreAccessLevel.toString() : undefined
        }
        isDisabledByAcl={isDisabled.toString()}
      />
    );
  });

  // Set displayName for easier debugging
  InputComponentWrapper.displayName = `withAuth(${Component.displayName ?? Component.name ?? "Component"})`;

  return InputComponentWrapper;
};
